export enum SocketEvents {
  MenuGenerationStatus = "menu:generation:status",
  OrderNew             = "order:new",
  OrderPending         = "order:pending",
  OrderUpdated         = "order:updated",
  OrderJoin            = "order:join",
  OrderAccept          = "order:accept",
  OrderReject          = "order:reject",
  OrderDone            = "order:done",
  OrderInProgress      = "order:in-progress",
  OrderRefund          = "order:refund",
  OrderRefundFailed    = "order:refund-failed",
}
